import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import FindAFixApp from './FindAFixApp';

const FindAFix: React.FC = () => {
  useEffect(() => {
    // Reset the background color for this component
    // @ts-expect-error
    document.querySelector('main').style.backgroundColor = '#ffffff';

    return () => {
      // Restore original background color
      // @ts-expect-error
      document.querySelector('main').style.backgroundColor = '#0962a1';
    };
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <FindAFixApp />
    </Box>
  );
};

export default FindAFix;